<main class="bg-gray-50 dark:bg-gray-900">
  <router-outlet></router-outlet>
</main>